const SET_FEATURE_TOGGLES = "feature-toggles/SET";
const setFeatureToggles = (payload) => ({
  type: SET_FEATURE_TOGGLES,
  payload
});
export {
  SET_FEATURE_TOGGLES,
  setFeatureToggles
};
//# sourceMappingURL=actions.js.map
